import * as ActionTypes from '../constants/ActionTypes';

export function applicationInit() {
  return {
    type: ActionTypes.APPLICATION_INIT
  };
}



// WEBPACK FOOTER //
// src/actions/app.js